import tiny_sourcemap from 'tiny-source-map'
import { jsy_transpile, version } from './transpile.jsy'

const _jsy_srcmap_ctx = @{}
  i: 1, ts: Date.now().toString(36)

export function jsy_transpile_srcmap(jsy_src, ... args) ::
  let source_ref = null == args[0] || 'object' !== typeof args[0] ? args.shift() : null
  let opt = args.pop() || {}

  if null == source_ref ::
    source_ref = `<jsy-${_jsy_srcmap_ctx.i++}-${_jsy_srcmap_ctx.ts}>.jsy`

  const srcmap = !opt.sourcemap ? null
    : opt.create_sourcemap
      ? opt.create_sourcemap()
      : tiny_sourcemap()

  if null !== srcmap ::
    srcmap.setSourceContent @ source_ref, jsy_src

  let code = jsy_transpile @ jsy_src, @{}
    addSourceMapping(arg) ::
      if null == srcmap :: return
      if source_ref ::
        arg.source = source_ref
      srcmap.addMapping(arg)

    inlineSourceMap() ::
      if srcmap && 'inline' == opt.sourcemap ::
        return srcmap.toString()

    ... opt

  return opt.as_rec ? {code, srcmap} : code

export { version, jsy_transpile_srcmap as default }
